// RoleCheck.js
import { Navigate } from "react-router-dom";

export default function RoleCheck({ user }) {
  switch (user.role) {
    case "student":
      return <Navigate to="/main" replace />;
    case "teacher":
      return <Navigate to="/main/teacher" replace />;
    case "parents":
      return <Navigate to="/main/parents" replace />;
    default:
      return <Navigate to="/" replace />;
  }
}
